import React from 'react';
import { Row, DatePicker } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import DF from 'DisplayFramework';

const TabContractReversal = (props: any) => (
  <DF.Provider pagcode="tabContractReversal">
    <Row>
      <FormInput
        col
        xs={24}
        lg={12}
        name="parvalue"
        comcode="reason"
        rules={[{ required: true }]}
      >
        <ParListSelect parcode="REVREASON" />
      </FormInput>
      <FormInput
        col
        xs={24}
        lg={12}
        name="pardate"
        comcode="reversaldate"
        rules={[{ required: true }]}
      >
        <DatePicker />
      </FormInput>
      <FormInput col xs={24} lg={24} name="comment" comcode="comment">
        <TextArea rows={5} />
      </FormInput>
    </Row>
  </DF.Provider>
);

export default TabContractReversal;
